import { StateUtils } from '@spartacus/core';
import { Cutting, CuttingRequest } from '../../../../../core/model';
import { CartEntryCuttingActionTypes } from '../actions/cart-entry-cutting.action';
import { CartActions } from '../actions/index';

export const initialState: Cutting = undefined;

export function reducer(state = initialState, action: CartActions.CartEntryCuttingActions | StateUtils.LoaderAction): Cutting {
  switch (action.type) {
    case CartEntryCuttingActionTypes.AddCartEntryCuttingSuccess: {
      const cutting: CuttingRequest = action.payload.cutting;
      return {
        ...state,
        length: cutting.daughterLength,
        width: cutting.daughterLength,
        dustFree: cutting.dustFree,
        perpendicular: cutting.perpendicular,
        template: cutting.templateCode,
        packaging: cutting.packagingCode,
        numberOfCuts: cutting.numberOfCuts,
        numberOfDaughters: cutting.numberOfDaughters,
      };
    }
    case CartEntryCuttingActionTypes.RemoveCartEntryCuttingSuccess: {
      return initialState;
    }
  }
  return state;
}
